import { capitalize } from 'inflection';
import { MarketingCampaignFields } from "../../types/request.types";
import { formatDate } from "../../lib/date-time-formatters";

import classes from "./Request.module.css";

interface MarketingCampaignProps {
  request: MarketingCampaignFields;
}

const MarketingCampaign = ({ request }: MarketingCampaignProps) => (
  <dl className={classes.details}>
    <dt>Name</dt>
    <dd>{request.name}</dd>
    <dt>Project type</dt>
    <dd>{request.project_type && capitalize(request.project_type)}</dd>
    <dt>Budget</dt>
    <dd>{request.budget}</dd>
    <dt>When to begin?</dt>
    <dd>
      {request.when_to_begin && formatDate(request.when_to_begin)}
    </dd>
    <dt>Description</dt>
    <dd dangerouslySetInnerHTML={{__html: request.description || ''}}></dd>
    <dt>Requested completion date</dt>
    <dd>
      {request.requested_completion_date && formatDate(request.requested_completion_date)}
    </dd>
  </dl>
);

export default MarketingCampaign;
